import './bootstrap';
import '../css/app.css';
import '../css/syntax.css';
import '../css/ninthorder.scss';
import 'flowbite';
import './header';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

let bugsnagVue = null;
if (process.env.NODE_ENV === 'production') {
    Bugsnag.start({
        apiKey: '729c2f12101b4608a72ce41bca0f2ca6',
        plugins: [new BugsnagPluginVue()]
    });
    bugsnagVue = Bugsnag.getPlugin('vue');
}
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from "pinia"
import { createPersistedState } from "pinia-plugin-persistedstate";
import SideMenuComponent from './components/Layout/SideMenuComponent.vue'
import PharmacyButtonComponent from './components/Layout/PharmacyButtonComponent.vue'
import NotifyButtonComponent from './components/Layout/NotifyButtonComponent.vue'
import DocumentButtonComponent from './components/Layout/DocumentButtonComponent.vue'
import ErrorNotifyButtonComponent from './components/Layout/ErrorNotifyButtonComponent.vue'
import HelpButtonComponent from './components/Layout/HelpButtonComponent.vue'
import ChatButtonComponent from './components/Layout/ChatButtonComponent.vue'
import ProfileButtonComponent from './components/Layout/ProfileButtonComponent.vue'
import DashboardComponent from './components/Main/Dashboard/DashboardComponent.vue'
import PharmacyMedicineComponent from './components/Main/PharmacyMedicine/PharmacyMedicineComponent.vue'
import PharmacyPrescriptComponent from './components/Main/PharmacyPrescript/PharmacyPrescriptComponent.vue'
import PharmacyRelationComponent from './components/Main/PharmacyRelation/PharmacyRelationComponent.vue'
import WholesalerComponent from './components/Main/Wholesaler/WholesalerComponent.vue'
import EnterRefundComponent from './components/Main/EnterRefund/EnterRefundComponent.vue'
import OrderComponent from './components/Main/Order/OrderComponent.vue'
import OrderHistoryComponent from './components/Main/OrderHistory/OrderHistoryComponent.vue'
import StockComponent from './components/Main/Stock/StockComponent.vue'
import ConvertComponent from './components/Main/Convert/ConvertComponent.vue'
import DebugComponent from './components/Main/Debug/DebugComponent.vue'
import NonMedicineComponent from './components/Main/NonMedicine/NonMedicineComponent.vue'
import HeadPharmacyMedicineComponent from './components/Main/Head/PharmacyMedicineComponent.vue'
import EstimateComponent from './components/Main/Estimate/EstimateComponent.vue'
import SpappHomeComponent from './components/Spapp/HomeComponent.vue'
import SpappHistoryComponent from './components/Spapp/HistoryComponent.vue'
import SpappAuditCheckComponent from './components/Spapp/AuditCheckComponent.vue'
import SpappStockControlComponent from './components/Spapp/StockControlComponent.vue'
import SpappDeliveryConfirmationComponent from './components/Spapp/DeliveryConfirmationComponent.vue'
import SpappOrderComponent from './components/Spapp/OrderComponent.vue'
import SpappBarcodeReaderSettingComponent from './components/Spapp/BarcodeReaderSettingComponent.vue'
import PasswordBox from './compositions/PasswordBox.vue'

const pinia = createPinia();
pinia.use(createPersistedState());
//VueLazyLoを一番最初にuseすること
//deliveryUplaod.use(VueLazyLoad,{
//    prelaod:1.3,
//    error:"../../images/not_found.png",
//    loading:"../../images/now_loading.png",
//    attempt:1
//});
if (document.getElementById('header') != null) {
    const header = createApp({}).use(pinia).use(bugsnagVue);
    header.component('PharmacyButtonComponent',PharmacyButtonComponent);
    header.component('DocumentButtonComponent',DocumentButtonComponent);
    header.component('NotifyButtonComponent',NotifyButtonComponent);
    header.component('ErrorNotifyButtonComponent',ErrorNotifyButtonComponent);
    header.component('HelpButtonComponent',HelpButtonComponent);
    header.component('ChatButtonComponent',ChatButtonComponent);
    header.component('ProfileButtonComponent',ProfileButtonComponent);
    header.mount('#header')
}
if (document.getElementById('sidemenu') != null) {
    const sidemenu = createApp({}).use(pinia).use(bugsnagVue);
    sidemenu.component('SideMenuComponent',SideMenuComponent);
    sidemenu.mount('#sidemenu')
}

if (document.getElementById('pharmacy_medicine') != null) {
    const pharmacyMedicine = createApp({}).use(pinia).use(bugsnagVue);
    pharmacyMedicine.component('PharmacyMedicineComponent',PharmacyMedicineComponent);
    pharmacyMedicine.mount('#pharmacy_medicine')
}

if (document.getElementById('pharmacy_prescript') != null) {
    const pharmacyPrescript = createApp({}).use(pinia).use(bugsnagVue);
    pharmacyPrescript.component('PharmacyPrescriptComponent',PharmacyPrescriptComponent);
    pharmacyPrescript.mount('#pharmacy_prescript')
}

if (document.getElementById('pharmacy_relation') != null) {
    const pharmacyRelation = createApp({}).use(pinia).use(bugsnagVue);
    pharmacyRelation.component('PharmacyRelationComponent',PharmacyRelationComponent);
    pharmacyRelation.mount('#pharmacy_relation')
}

if (document.getElementById('whole_saler') != null) {
    const wholeSaler = createApp({}).use(pinia).use(bugsnagVue);
    wholeSaler.component('WholeSalerComponent',WholesalerComponent);
    wholeSaler.mount('#whole_saler');
}

if (document.getElementById('enter_refund') != null) {
    const enterRefund = createApp({}).use(pinia).use(bugsnagVue);
    enterRefund.component('EnterRefundComponent',EnterRefundComponent);
    enterRefund.mount('#enter_refund');
}

if (document.getElementById('dashboard') != null) {
    const dashboard = createApp({}).use(pinia).use(bugsnagVue);
    dashboard.component('DashboardComponent',DashboardComponent);
    dashboard.mount('#dashboard');
}

if (document.getElementById('order') != null) {
    const order = createApp({}).use(pinia).use(bugsnagVue);
    order.component('OrderComponent',OrderComponent);
    order.mount('#order');
}

if (document.getElementById('order_history') != null) {
    const orderHistory = createApp({}).use(pinia).use(bugsnagVue);
    orderHistory.component('OrderHistoryComponent',OrderHistoryComponent);
    orderHistory.mount('#order_history');
}

if (document.getElementById('stock') != null) {
    const stock = createApp({}).use(pinia).use(bugsnagVue);
    stock.component('StockComponent',StockComponent);
    stock.mount('#stock');
}

if (document.getElementById('convert') != null) {
    const convert = createApp({}).use(pinia).use(bugsnagVue);
    convert.component('ConvertComponent',ConvertComponent);
    convert.mount('#convert');
}

if (document.getElementById('non_medicine') != null) {
    const nonMedicine = createApp({}).use(pinia).use(bugsnagVue);
    nonMedicine.component('NonMedicineComponent',NonMedicineComponent);
    nonMedicine.mount('#non_medicine');
}

if (document.getElementById('head_pharmacy_medicine') != null) {
    const head = createApp({}).use(pinia).use(bugsnagVue);
    head.component('HeadPharmacyMedicineComponent',HeadPharmacyMedicineComponent);
    head.mount('#head_pharmacy_medicine');
}

if (document.getElementById('estimate') != null) {
    const estimate = createApp({}).use(pinia).use(bugsnagVue);
    estimate.component('EstimateComponent',EstimateComponent);
    estimate.mount('#estimate');
}

if (document.getElementById('spapp_home') != null) {
    const spappHome = createApp({}).use(pinia).use(bugsnagVue);
    spappHome.component('HomeComponent',SpappHomeComponent);
    spappHome.mount('#spapp_home');
}
if (document.getElementById('spapp_history') != null) {
    const spappHistory = createApp({}).use(pinia).use(bugsnagVue);
    spappHistory.component('HistoryComponent',SpappHistoryComponent);
    spappHistory.mount('#spapp_history');
}
if (document.getElementById('spapp_audit_check') != null) {
    const spappAuditCheck = createApp({}).use(pinia).use(bugsnagVue);
    spappAuditCheck.component('AuditCheckComponent',SpappAuditCheckComponent);
    spappAuditCheck.mount('#spapp_audit_check');
}
if (document.getElementById('spapp_stock_control') != null) {
    const spappStockControl = createApp({}).use(pinia).use(bugsnagVue);
    spappStockControl.component('StockControlComponent',SpappStockControlComponent);
    spappStockControl.mount('#spapp_stock_control');
}
if (document.getElementById('spapp_delivery_confirmation') != null) {
    const spappDeliveryConfirmation = createApp({}).use(pinia).use(bugsnagVue);
    spappDeliveryConfirmation.component('DeliveryConfirmationComponent',SpappDeliveryConfirmationComponent);
    spappDeliveryConfirmation.mount('#spapp_delivery_confirmation');
}
if (document.getElementById('spapp_order') != null) {
    const spappOrder = createApp({}).use(pinia).use(bugsnagVue);
    spappOrder.component('OrderComponent',SpappOrderComponent);
    spappOrder.mount('#spapp_order');
}
if (document.getElementById('spapp_barcode_reader_setting') != null) {
    const SpappBarcodeReaderSetting = createApp({}).use(pinia).use(bugsnagVue);
    SpappBarcodeReaderSetting.component('BarcodeReaderSettingComponent',SpappBarcodeReaderSettingComponent);
    SpappBarcodeReaderSetting.mount('#spapp_barcode_reader_setting');
}

if (document.getElementById('password') != null) {
    const password = createApp({}).use(pinia).use(bugsnagVue);
    password.component('PasswordBox',PasswordBox);
    password.mount('#password');
}
if (document.getElementById('id_old_password') != null) {
    const oldPassword = createApp({}).use(pinia).use(bugsnagVue);
    oldPassword.component('PasswordBox',PasswordBox);
    oldPassword.mount('#id_old_password');
}
if (document.getElementById('id_new_password1') != null) {
    const newPassword1 = createApp({}).use(pinia).use(bugsnagVue);
    newPassword1.component('PasswordBox',PasswordBox);
    newPassword1.mount('#id_new_password1');
}
if (document.getElementById('id_new_password2') != null) {
    const newPassword2 = createApp({}).use(pinia).use(bugsnagVue);
    newPassword2.component('PasswordBox',PasswordBox);
    newPassword2.mount('#id_new_password2');
}
if (document.getElementById('debug') != null) {
    const debugComponent = createApp({}).use(pinia).use(bugsnagVue);
    debugComponent.component('DebugComponent',DebugComponent);
    debugComponent.mount('#debug');
}
